import { useEffect, useState } from "react";
import { useOnboarding } from "@/hooks/useOnboarding";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight, X } from "lucide-react";

export const OnboardingTrigger = () => {
  const { hasCompletedOnboarding, isLoading, startTour } = useOnboarding();
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    // Show welcome dialog for new users after a short delay
    if (!isLoading && hasCompletedOnboarding === false) {
      const timer = setTimeout(() => {
        setShowWelcome(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isLoading, hasCompletedOnboarding]);

  const handleStartTour = () => {
    setShowWelcome(false);
    // Small delay to let dialog close animation complete
    setTimeout(() => {
      startTour();
    }, 300);
  };

  const handleSkip = () => {
    setShowWelcome(false);
  };

  if (isLoading || hasCompletedOnboarding !== false) {
    return null;
  }

  return (
    <Dialog open={showWelcome} onOpenChange={setShowWelcome}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Sparkles className="h-8 w-8 text-primary" />
          </div>
          <DialogTitle className="text-2xl">Welcome to Habilou! 🌸</DialogTitle>
          <DialogDescription className="text-base mt-2">
            Let's take a quick tour to help you get started on your habit-building journey.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 mt-4">
          <Button onClick={handleStartTour} className="w-full text-white">
            Start Tour
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <Button variant="ghost" onClick={handleSkip} className="w-full">
            <X className="mr-2 h-4 w-4" />
            Skip for now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
